import styles from "./primitives.module.css";
import { cn } from "../../utils/cn";

const TONE = {
  default: null,
  success: styles.badgeSuccess,
  warning: styles.badgeWarning,
  danger: styles.badgeDanger,
  info: styles.badgeInfo,
};

export default function TRABadge({ tone = "default", className, children, ...rest }) {
  return (
    <span className={cn(styles.badge, TONE[tone], className)} {...rest}>
      {children}
    </span>
  );
}
